<template>
    <popup ref="popup" class="popup" :show.sync="openPop" :hideTitle="true" :limitMinHeight="false" >
        <div class="container">
            <div class="list">
            <div class="checkbox-item" @click="choose(opt)" v-for="opt in options">
                {{ opt.text }}
              </div>
        </div>
        </div>
    </popup>
</template>
<script>
import Popup from '@/components/Popup';
export default {
  components: {
    Popup,
  },
  data() {
    return {
      openPop: false,
      options: [],
      choosedValue: [],
    };
  },
  methods: {
    show(params) {
      setTimeout(() => {
        this.openPop = true;
      }, 400);
      this.options = params.options;
      this.widgetSymbol = params.widgetSymbol;
    },
    cancel() {
      this.openPop = false;
    },
    choose(opt) {
      this.openPop = false;
      this.$emit('singleSelectChange', {
        choosedValue: opt.value,
        widgetSymbol: this.widgetSymbol,
      });
    },
  },
};
</script>

<style lang="less" scoped>
    .container {
        padding: 32px 16px 0px;
        box-sizing: border-box;

    }
    .list {
        .checkbox-item {
            font-size: 14px;
            line-height: 20px;
            padding: 12px 0;
            box-sizing: border-box;
            border-bottom: 0.5px solid #EBEDF0;
            text-align: left;
            display: flex;
            align-items: center;
            .input-checkbox {
                margin-right: 10px;
            }
        }
    }
</style>
